import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import { memo, MouseEvent, ReactElement, useEffect, useState } from 'react';

import { ReactComponent as InfoIcon } from '~/ui/assets/images/info.svg';

import { useStoreActions, useStoreState } from '~/store/hooks';
import Tooltip from '~/ui/components/common/Tooltip';
import { systemPromptDescription } from '~/ui/pages/AiManagement/constants';

import variables from '~/ui/assets/styles/colors.module.scss';
import styles from '../../AiAssist.module.scss';

const AISettings = (): ReactElement => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const { aiPrompt } = useStoreState(state => state.aiAssist);
  const { onGetAiPrompt } = useStoreActions(actions => actions.aiAssist);
  const { current } = useStoreState(state => state.user);

  useEffect(() => {
    if (current?.clinic?.id) {
      onGetAiPrompt({ clinicId: current.clinic.id });
    }
  }, [current?.clinic?.id, onGetAiPrompt]);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(prev => !prev);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  if (!aiPrompt) {
    return null;
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <section className={styles.settingsRoot}>
        <IconButton
          className={styles.settingsIconButton}
          aria-describedby="ai-settings-tooltip"
          onClick={handleClick}
        >
          <InfoIcon color={variables.colorBlack} width={20} />
        </IconButton>

        <Popper open={open} anchorEl={anchorEl} placement="bottom-end" transition>
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper className={styles.settingsPaper}>
                <div className={styles.settingsTitleWrapper}>
                  <Typography variant="h6" className={styles.title}>
                    System Prompt
                  </Typography>
                  <Tooltip
                    icon={<InfoIcon color={variables.colorBlack} width={20} />}
                    body={<Typography>{systemPromptDescription}</Typography>}
                    className={styles.formTooltip}
                  />
                </div>
                <div className={styles.settingsPromptWrapper}>{aiPrompt}.</div>
              </Paper>
            </Fade>
          )}
        </Popper>
      </section>
    </ClickAwayListener>
  );
};

export default memo(AISettings);
